import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

const POSITION = { x: 0, y: 0 };

const Draggable: FC<any> = ({ children, id, onDrag, onDragEnd }) => {
  const [state, setState] = useState({
    isDragging: false,
    origin: POSITION,
    translation: POSITION,
  });

  const handleMouseDown = useCallback(({ clientX, clientY }) => {
    setState(prevState => ({
      ...prevState,
      isDragging: true,
      origin: { x: clientX, y: clientY },
    }));
  }, []);

  const handleMouseMove = useCallback(
    ({ clientX, clientY }) => {
      const translation = {
        x: clientX - state.origin.x,
        y: clientY - state.origin.y,
      };

      setState(prevState => ({
        ...prevState,
        translation,
      }));

      onDrag({ translation, id });
    },
    [state.origin, onDrag, id],
  );

  const handleMouseUp = useCallback(() => {
    setState(prevState => ({
      ...prevState,
      isDragging: false,
    }));

    onDragEnd();
  }, [onDragEnd]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (state.isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);

      setState(prevState => ({ ...prevState, translation: { x: 0, y: 0 } }));
    }
  }, [state.isDragging, handleMouseMove, handleMouseUp]);

  const DragWrapper = styled.div`
    ${useMemo(
      () => ({
        cursor: state.isDragging ? '-webkit-grabbing' : '-webkit-grab',
        transform: `translate(${state.translation.x}px, ${state.translation.y}px)`,
        transition: state.isDragging ? 'none' : 'transform 500ms',
        zIndex: state.isDragging ? 2 : 1,
        position: state.isDragging ? 'absolute' : 'relative',
        textAlign: 'left',
      }),
      [state.isDragging, state.translation],
    )}
  `;

  return <DragWrapper onMouseDown={handleMouseDown}>{children}</DragWrapper>;
};

export default Draggable;
